'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_OAuthUserData(provider, providerId, data) {
  this.Sr = null;
  this.Ss = null;
  this.Sq = null;
  this.Sr = provider;
  this.Ss = providerId;
  this.Sq = data;
}
export { $c_Lmealorama_OAuthUserData as $c_Lmealorama_OAuthUserData };
$p = $c_Lmealorama_OAuthUserData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_OAuthUserData;
/** @constructor */
function $h_Lmealorama_OAuthUserData() {
}
export { $h_Lmealorama_OAuthUserData as $h_Lmealorama_OAuthUserData };
$h_Lmealorama_OAuthUserData.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 1017553148, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_OAuthUserData)) {
    if (((this.Sr === x$0.Sr) && (this.Ss === x$0.Ss))) {
      var x = this.Sq;
      var x$2 = x$0.Sq;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 3;
});
$p.r = (function() {
  return "OAuthUserData";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.Sr;
      break;
    }
    case 1: {
      return this.Ss;
      break;
    }
    case 2: {
      return this.Sq;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_OAuthUserData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jK)));
}
export { $isArrayOf_Lmealorama_OAuthUserData as $isArrayOf_Lmealorama_OAuthUserData };
var $d_Lmealorama_OAuthUserData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_OAuthUserData, "mealorama.OAuthUserData", ({
  jK: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_OAuthUserData as $d_Lmealorama_OAuthUserData };
//# sourceMappingURL=mealorama.-O-Auth-User-Data.js.map
